<template>
  <div class="space-y-2">
    <p>
      For users in the European Economic Area (EEA), we comply with the General Data Protection Regulation (GDPR) regarding cookie usage.
    </p>
    <p><strong>Lawful Basis for Use:</strong></p>
    <ul class="list-disc list-inside space-y-1">
      <li>
        <strong>Contractual necessity:</strong> The JWT cookie is essential to authenticate your account and provide secure access.
      </li>
      <li>
        <strong>Consent:</strong> By signing up or logging in, you consent to the use of this cookie and local storage for necessary functionality.
      </li>
    </ul>
    <p>
      We do not use any non-essential cookies that would require explicit opt-in consent under GDPR.
    </p>
  </div>
</template>